import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Clinic } from '../../../../shared/state/clinic/clinic.store';

@Component({
    selector: 'app-clinic-list',
    templateUrl: './clinic-list.component.html',
    styleUrls: ['./clinic-list.component.scss'],
})
export class ClinicListComponent implements OnInit {
    @Input() clinics: Clinic[];
    @Output() clinicClickedEvent = new EventEmitter<Clinic>();

    /** Flowwwer template */
    @Input() scrollable = true; //TODO! Esto me parece raro, si esto es true, si el padre no tiene heigh no sale nada

    ionContent: HTMLElement

    constructor() {}

    ngOnInit() {}
    
    onClinicClicked(clinic: Clinic) {
        this.clinicClickedEvent.emit(clinic);
    }
}
